module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/81905fa6829e39ae8fc173589e8cecfb.gif";